// import App from "./v1/App";
import App from "./v2/App";

export default App;
